export default [
  {
    width: '40px',
    value: 'edit',
    align: 'center',
    colModifiers:[
      { type: 'edit' }
    ],
    editPath: 'detailing/edit/'
  },
  { text: 'Детализация статуса', value: 'name' }
]
